import './scss/style.scss';
import 'bootstrap/dist/js/bootstrap.bundle.js';

import flatpickr from "flatpickr";
flatpickr.localize(flatpickr.l10ns[functions.getLang()]);
flatpickr.l10ns.default.firstDayOfWeek = 1;
import 'flatpickr/dist/l10n/hr.js';
import 'flatpickr/dist/l10n/de.js';
import 'flatpickr/dist/l10n/da.js';
import 'flatpickr/dist/l10n/sv.js';
import 'flatpickr/dist/l10n/it.js';
import 'flatpickr/dist/l10n/sl.js';
import 'flatpickr/dist/l10n/nl.js';
import 'flatpickr/dist/l10n/fr.js';
import 'flatpickr/dist/l10n/es.js';
import 'flatpickr/dist/l10n/pl.js';
import 'flatpickr/dist/l10n/no.js';
import 'flatpickr/dist/l10n/hu.js';
import 'flatpickr/dist/l10n/cs.js';
import 'flatpickr/dist/l10n/sk.js';


import 'lightgallery/src/js/lightgallery.js';
import 'lightgallery/modules/lg-fullscreen.js';
import 'lightgallery/modules/lg-thumbnail.js';

import 'select2';
import 'select2/dist/js/i18n/hr.js';

import lozad from 'lozad';

import functions from './js/functions.js';
import './js/loadGmap.js';
import './js/globals.js';
import './js/list.js';
import './js/details.js';
import './js/booking.js';
import './js/contact.js';
import './js/newsletter.js';
import './js/home.js';
import './js/landing.js';
import './js/admin-panel.js';
import './js/blog.js';
import './js/review.js';
//import './js/pagination.js';

import './js/gutenberg/gutenberg.js';

window.observer = lozad('.lozad', {
    rootMargin: '200px 200px',
    loaded: el => {
        $(el).triggerHandler('lozadLoaded');
    }
});

window.nobserver = lozad('.nlozad', {
    rootMargin: '200px 0px',
    loaded: el => {
        $.getScript("https://www.google.com/recaptcha/api.js?render=6LfphqggAAAAAAsli7qz4-HH3vF2YCh-KLYX4qPT");
    }
});
window.nobserver.observe();

window.observer.observe();
